export default function ProductsController(
  $scope,
  $filter,
  $state,
  productService,
  gettextCatalog,
) {
  'ngInject';

  //Local Variables
  $scope.allProducts = [];
  $scope.filteredProducts = [];
  $scope.searchText = '';
  $scope.previousSearchText = '';
  $scope.selectName = '';
  $scope.loading = true;

  //Pagination
  $scope.currentPage = 1;
  $scope.itemsPerPage = 20;
  $scope.maxSize = 3;

  $scope.pageChanged = function () {
    GTM_ListChanged('templatesPageChanged');
  };

  //applyFilter searchs the roles[] for anything matching the search input.
  $scope.applyFilter = function () {
    if ($scope.previousSearchText === $scope.searchText) return;
    $scope.filteredProducts = $filter('filter')($scope.allProducts, $scope.searchText);
    $scope.previousSearchText = $scope.searchText;
    GTM_ListChanged('templatesFiltered');
  };

  //order() is used to sort the table based on it's column names, currently defaulted to the 'name' column.
  $scope.predicate = 'name';
  $scope.reverse = false;
  $scope.order = function (predicate) {
    $scope.reverse = $scope.predicate === predicate ? !$scope.reverse : false;
    $scope.predicate = predicate;
    GTM_ListChanged('templatesOrderChanged');
  };

  productService.getAllProducts().then(function (response) {
    $scope.allProducts = response.data;
    $scope.filteredProducts = $scope.allProducts.slice();
    $scope.loading = false;
    GTM_ListChanged('templatesLoaded');
  }, handleError);

  //general error handler.
  function handleError(error) {
    $scope.loading = false;
    var errorMsg = gettextCatalog.getString(
      'An error occurred while retrieving template information.',
    );
    if (error.data || error.status) {
      if (error.data.message) {
        errorMsg =
          error.data.message +
          ' ' +
          (error.status.toString() + ' - ' + error.statusText.toString());
      } else {
        errorMsg += ': ' + (error.status.toString() + ' - ' + error.statusText.toString());
      }
    } else {
      errorMsg += gettextCatalog.getString('. Please try again later.');
    }
    $scope.onLoadErrorFlag = true;
    $scope.onLoadErrorText = errorMsg;
  }

  function GTM_ListChanged(event) {
    window.dataLayer.push({
      event: event,
      data: {
        total: $scope.allProducts.length,
        totalFiltered: $scope.filteredProducts.length,
        pageNumber: $scope.currentPage,
        sortDirection: $scope.reverse ? 'descending' : 'ascending',
      },
    });
  }
} //end products controller
